import { all, takeLatest, call, put } from "redux-saga/effects";
import { message } from 'antd';
import { FETCH_PENDING_VISITS, FETCH_PENDING_VISITS_START, FETCH_PENDING_VISITS_SUCCESS, FETCH_PENDING_VISITS_ERROR, SET_PENDING_VISITORS_PAGINATION } from "../../actions/receptionist/pendingVisitorsAction";
import { fetchPendingVisitorsAPI } from "../../../services/pending-visitors-service";


function* fetchPendingVisitors({ payload }) {
    try {
        yield put({ type: FETCH_PENDING_VISITS_START })
        const response = yield call(fetchPendingVisitorsAPI, payload)
        if (response.success) {
            const pagination = {
                currentPage: payload.filterRequest.page,
                pageSize: payload.filterRequest.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_PENDING_VISITS_SUCCESS, pendingVisitors: response.data.unverifiedVisitsReport.length > 0 ? [...response.data.unverifiedVisitsReport] : [] })
            yield put({ type: SET_PENDING_VISITORS_PAGINATION, pagination: pagination });
        } else {
            message.error('Failed to fetch visits!');
            yield put({ type: FETCH_PENDING_VISITS_ERROR })
        }
    }
    catch (error) {
        message.error('Failed to fetch visits!');
    }
}


function* pendingVisitorsWatcher() {
    yield takeLatest(FETCH_PENDING_VISITS, fetchPendingVisitors)
}

export default function* rootSaga() {
    yield all([pendingVisitorsWatcher()])
}